module.exports = __webpack_public_path__ + "img/emoji_baixo.982abf02.png";